<div class="centered-auth-page">
  <!-- Full Screen Background Image -->
  <div class="auth-bg-wrapper">
    <img src="assets/images/login2.jpg" alt="Background Blur" class="auth-bg-blur-img">
    <img src="assets/images/login2.jpg" alt="Wedding Couple" class="auth-bg-main-img">
    <div class="auth-bg-overlay"></div>
  </div>

  <!-- Centered Login Card -->
  <div class="login-floating-card">
    <div class="auth-header">
      <a routerLink="/" class="logo">Weddingly Matrimony</a>
      <h2>Welcome Back</h2>
      <p class="subtitle">Continue your journey to finding the perfect life partner.</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label for="email">Email Address</label>
        <div class="input-with-icon">
          <span class="material-symbols-outlined input-icon">mail</span>
          <input type="email" id="email" formControlName="email" class="warm-input" placeholder="yourname@domain.com"
            [class.invalid]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid">
        </div>
        <span class="error-msg" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('required')">
          Email is required
        </span>
        <span class="error-msg" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('email')">
          Please enter a valid email address
        </span>
      </div>

      <div class="form-group password-group">
        <label for="password">Password</label>
        <div class="input-with-icon">
          <span class="material-symbols-outlined input-icon">lock</span>
          <input [type]="hidePassword ? 'password' : 'text'" id="password" formControlName="password" class="warm-input"
            placeholder="••••••••"
            [class.invalid]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
          <button type="button" class="password-toggle" (click)="togglePassword()"
            aria-label="Toggle Password Visibility">
            <span class="material-symbols-outlined">{{ hidePassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
        <span class="error-msg" *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
          Password is required
        </span>
      </div>

      <!-- Remember Me & Forgot Password -->
      <div class="form-actions-row">
        <label class="remember-me-label">
          <input type="checkbox" id="rememberMe" class="custom-checkbox">
          <span>Remember me</span>
        </label>
        <a href="#" class="forgot-password-link" (click)="$event.preventDefault(); openForgotPassword()">Forgot Password?</a>
      </div>

      <div *ngIf="showForgotPassword" class="forgot-password-panel">
        <div class="forgot-password-header">
          <h3>Reset Password</h3>
          <button type="button" class="forgot-password-close" (click)="closeForgotPassword()" aria-label="Close reset panel">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
        <p class="forgot-password-copy">{{ forgotPasswordMessage }}</p>

        <form [formGroup]="forgotPasswordForm" class="forgot-password-form">
          <div class="form-group" *ngIf="forgotPasswordStep === 'email'">
            <label for="forgotEmail">Email Address</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">mail</span>
              <input type="email" id="forgotEmail" formControlName="forgotEmail" class="warm-input"
                placeholder="yourname@domain.com"
                [class.invalid]="forgotPasswordForm.get('forgotEmail')?.touched && forgotPasswordForm.get('forgotEmail')?.invalid">
            </div>
          </div>

          <ng-container *ngIf="forgotPasswordStep === 'otp'">
            <div class="form-group">
              <label for="forgotOtp">OTP</label>
              <div class="input-with-icon">
                <span class="material-symbols-outlined input-icon">pin</span>
                <input type="text" id="forgotOtp" formControlName="forgotOtp" class="warm-input" placeholder="Enter 6 digit OTP"
                  [class.invalid]="forgotPasswordForm.get('forgotOtp')?.touched && forgotPasswordForm.get('forgotOtp')?.invalid">
              </div>
            </div>

            <div class="form-group">
              <label for="forgotPassword">New Password</label>
              <div class="input-with-icon">
                <span class="material-symbols-outlined input-icon">lock</span>
                <input type="password" id="forgotPassword" formControlName="forgotPassword" class="warm-input"
                  placeholder="Choose a new password"
                  [class.invalid]="forgotPasswordForm.get('forgotPassword')?.touched && forgotPasswordForm.get('forgotPassword')?.invalid">
              </div>
            </div>
          </ng-container>

          <div class="forgot-password-actions">
            <button *ngIf="forgotPasswordStep === 'email'" type="button" class="gold-button submit-btn" (click)="requestForgotPasswordOtp()" [disabled]="forgotPasswordLoading">
              <span>{{ forgotPasswordLoading ? 'Sending...' : 'Send OTP' }}</span>
            </button>
            <button *ngIf="forgotPasswordStep === 'otp'" type="button" class="gold-button submit-btn" (click)="resetPasswordWithOtp()" [disabled]="forgotPasswordLoading">
              <span>{{ forgotPasswordLoading ? 'Updating...' : 'Reset Password' }}</span>
            </button>
            <button type="button" class="text-button" (click)="forgotPasswordStep === 'otp' ? forgotPasswordStep = 'email' : closeForgotPassword()">
              {{ forgotPasswordStep === 'otp' ? 'Back' : 'Cancel' }}
            </button>
          </div>
        </form>
      </div>

      <button type="submit" class="gold-button submit-btn">
        <span>Log In</span>
        <span class="material-symbols-outlined">login</span>
      </button>
    </form>

    <div class="auth-footer">
      <p>Don't have an account? <a routerLink="/signup-basic">Sign up for free</a></p>
    </div>

    <!-- Trust Badge Grid -->
    <div class="login-trust-badges">
      <div class="badge-item">
        <span class="check-icon">✓</span>
        <span>Verified Profiles</span>
      </div>
      <div class="badge-item">
        <span class="check-icon">✓</span>
        <span>Secure Messaging</span>
      </div>
      <div class="badge-item">
        <span class="check-icon">✓</span>
        <span>Privacy Protected</span>
      </div>
    </div>
  </div>
</div>